"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ResourcesApi = exports.Action = void 0;
const SdPlatformSdkContext_1 = require("../../SdPlatformSdkContext");
/**
 * Actions enum.
 */
var Action;
(function (Action) {
    Action["Post"] = "post";
    Action["Get"] = "get";
    Action["Delete"] = "delete";
    Action["Patch"] = "patch";
})(Action = exports.Action || (exports.Action = {}));
/**
 * Base ShapeDiver Platform resource API. Implement this for new resources.
 */
class ResourcesApi {
    constructor(__context, __authApi) {
        this.__context = __context;
        this.__authApi = __authApi;
        this.__commonPath = "api/v1";
        this.__api = __context.api;
    }
    __getPath(pathSufix = null) {
        if (pathSufix == null) {
            return `${this.__commonPath}/${this.__resourcePath}`;
        }
        return `${this.__commonPath}/${this.__resourcePath}/${pathSufix}`;
    }
    __resolveRequestConfig() {
        return {
            access_token: this.__context.accessTokenDetails.access_token,
            client_id: this.__context.config.clientId
        };
    }
    __refreshTokenIfExpired() {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.__context.accessTokenState == SdPlatformSdkContext_1.SdPlatformAccessTokenState.Expired) {
                yield this.__authApi.refreshToken();
            }
            return Promise.resolve();
        });
    }
    __schema(requestId) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.__refreshTokenIfExpired();
            return this.__api.get(requestId, this.__getPath(), this.__resolveRequestConfig());
        });
    }
    /**
     * Base get request
     * @param { string } id - the id of a resource.
     * @param { null|Array<string> } embed - resources to embed.
     */
    __get(requestId, id, embed) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.__refreshTokenIfExpired();
            return yield this.__api.get(requestId, this.__getPath(id), this.__resolveRequestConfig(), { embed });
        });
    }
    __query(requestId, body = {}) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.__refreshTokenIfExpired();
            return yield this.__api.post(requestId, this.__getPath("query"), body, this.__resolveRequestConfig());
        });
    }
    __post(requestId, body) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.__refreshTokenIfExpired();
            return this.__api.post(requestId, this.__getPath(), body, this.__resolveRequestConfig());
        });
    }
    __patch(requestId, id, body) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.__refreshTokenIfExpired();
            return this.__api.patch(requestId, this.__getPath(id), body, this.__resolveRequestConfig());
        });
    }
    __delete(requestId, id) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.__refreshTokenIfExpired();
            return this.__api.delete(requestId, this.__getPath(id), this.__resolveRequestConfig());
        });
    }
    __action(requestId, action, pathSuffix, body, headers = {}) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.__refreshTokenIfExpired();
            if (action == Action.Get) {
                // @ts-ignore
                return this.__api[action](requestId, this.__getPath(pathSuffix), this.__resolveRequestConfig(), body);
            }
            if (action == Action.Delete) {
                // @ts-ignore
                return this.__api[action](requestId, this.__getPath(pathSuffix), this.__resolveRequestConfig());
            }
            // @ts-ignore
            return this.__api[action](requestId, this.__getPath(pathSuffix), body, this.__resolveRequestConfig(), headers);
        });
    }
}
exports.ResourcesApi = ResourcesApi;
//# sourceMappingURL=ResourcesApi.js.map